import React from "react";
import { Typography } from "@material-ui/core";
import {RouteComponentProps} from "react-router";
import {ShopErrorButtonConnectorProps} from "./container";
import { ActionButton } from "halifax";
import "./styles.scss";
import {
  CHANGE_DATES,
  isDateSelectionErrorType,
  isOccupancyErrorType,
} from "../ShopErrorCta/constants";
import {
  OccupancySelection
} from "../../../search/components/PremierCollectionSearchControl/components/OccupancySelection";
import {
  IOccupancySelectionVariant
} from "../../../search/components/PremierCollectionSearchControl/components/OccupancySelection/component";
import {
  OccupancySelection as MobileOccupancySelection
} from "../../../search/components/MobilePremierCollectionSearchControl/components/OccupancySelection";
import {
  IMobileOccupanySelectionVariant
} from "../../../search/components/MobilePremierCollectionSearchControl/components/OccupancySelection/component";


export interface IShopErrorButtonProps
  extends ShopErrorButtonConnectorProps,
    RouteComponentProps {
  isMobile?: boolean;
}

export const ShopErrorButton = (props: IShopErrorButtonProps) => {
    const { selectedListing, setOpenDatesModal, isMobile } = props;

    if (!selectedListing) {
      return null;
    }

    const { availability } = selectedListing;
    const failureReason = availability?.reasons?.[0]?.reason?.Reason;
    const isDateSelectionError = isDateSelectionErrorType(failureReason);
    const isOccupanySelectionError = isOccupancyErrorType(failureReason);

    if (isDateSelectionError) {
      return (
        <ActionButton
          className="b2b"
          onClick={() => setOpenDatesModal(true)}
          message={
            <Typography variant="h2" className="button-text">
              {CHANGE_DATES}
            </Typography>
          }
        />
      );
    }

    if (isOccupanySelectionError) {
        return isMobile ? (
          <MobileOccupancySelection
            maxOccupancy={selectedListing?.listing.terms.maxOccupancy}
            variant={IMobileOccupanySelectionVariant.BUTTON}
          />
        ) : (
          <OccupancySelection
            maxOccupancy={selectedListing?.listing.terms.maxOccupancy}
            variant={IOccupancySelectionVariant.BUTTON}
          />
        );
    }

    return null;
};
